export default __webpack_public_path__ + "static/media/dep2_5.4f71298d.png";